import PageTabs from '@/components/page/PageTabs';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import ConfigurationSection from './outputViewer/ConfigurationSection';
import HeaderSection from './outputViewer/HeaderSection';
import PayloadSection from './outputViewer/PayloadSection';
import ResponseSection from './outputViewer/ResponseSection';
import SummarySection from './outputViewer/SummarySection';
import useResponsive from '@/hooks/useResponsive.js';
import { action } from '@/lib/api.js';
import { workflowStepTabMemory } from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';

// This component shows up in the output panel of the workflow editor.

const OutputViewer = ({ search, output, onTabChange, responseCollapseAmount, enablePagination, stepId }) => {
  // This means an Axios request was made.
  const shouldDisplayHeaders = output?.meta?.response && output?.meta?.response?.request;
  const configurationSectionResult = ConfigurationSection({ request: output?.meta?.request, dependencies: output?.meta?.dependencies });
  const defaultTab = '1';
  const memoryTab = useArgSelector(workflowStepTabMemory, { stepId, tabKey: 'outputViewerTab' });
  const queryTab = useArgSelector(query, 'outputViewerTab');
  const activeTab = (stepId ? memoryTab : queryTab) || defaultTab;
  const { tablet } = useResponsive();

  const childrenMap = {
    1: <SummarySection search={search} output={output} enablePagination={enablePagination} />
  };

  const items = [{ value: '1', label: 'Summary' }];

  if (output?.meta?.request?.arguments || output?.meta?.dependencies) {
    if (configurationSectionResult !== null) {
      childrenMap['2'] = configurationSectionResult;
      items.push({ value: '2', label: tablet ? 'Config' : 'Configuration' });
    }
  }

  if (shouldDisplayHeaders) {
    childrenMap['3'] = <HeaderSection response={output?.meta?.response} />;
    items.push({ value: '3', label: 'Headers' });
  }

  if (output?.meta?.request && output?.meta?.request?.method?.toLowerCase() !== 'get') {
    childrenMap['4'] = <PayloadSection request={output?.meta?.request} stepId={stepId} />;
    items.push({ value: '4', label: 'Payload' });
  }

  if (output?.data) {
    childrenMap['5'] = <ResponseSection data={output?.data} collapseAmount={responseCollapseAmount} />;
    items.push({ value: '5', label: 'Response' });
  }

  const handleTabChange = (value) => {
    if (stepId) {
      action('SET_WORKFLOW_STEP_TAB_MEMORY', { stepId, tabKey: 'outputViewerTab', value });
    }
    onTabChange?.(value);
  };

  return (
    <div className="comp-output-viewer">
      <PageTabs items={items} tabKey={'outputViewerTab'} activeTab={stepId ? activeTab : undefined} defaultTab={defaultTab} onChange={handleTabChange} />
      <div className="content">{activeTab !== undefined && childrenMap[activeTab]}</div>
    </div>
  );
};

export default OutputViewer;
